<template>
    <div class="navigator" v-if="fullCalendar">
        <div class="date-scroller d-flex align-items-center" @click="backToList">

            <arrow class="mr-1" direction="left" amount="-1" @updateArrowDate="updateArrowDate"></arrow>
            <arrow direction="right" amount="1" @updateArrowDate="updateArrowDate"></arrow>

            <span>
                <vue-datepicker
                    :value="getExpandedDay"
                    v-on:selected="setExpandedDay"
                    :monday-first="false"
                    format="dd-MM-yyyy"
                    input-class=""
                    :required="false"
                    v-if="getCurrentView == 'agendaDay'">
                </vue-datepicker>
            </span>


            <!-- <span class="fs-largest text-center px-2" v-if="getCurrentView != 'agendaDay'">
                {{displayDate}}
            </span> -->

            <span class="fs-largest text-center px-2" v-if="getCurrentView != 'agendaDay'">
                {{fullCalendar.view.title}}
            </span>

            <div class="loader ml-3" v-if="getIsLoadingEvents">Loading...</div>

        </div>

        <div class="d-flex justify-content-center" style="flex-grow: 1" v-if="fullCalendar">
            <div class="btn-group d-flex">
                <!-- <span class="border-medium radius-normal p-2 text-center pointer" v-for="period in periods" :class="{'bg-color-6 lightest': period.value == fullCalendar.view.name, 'bg-lightest dark': period.value != fullCalendar.view.name}" @click="changeView(period.value)">{{period.label}}</span> -->
                <button type="button" class="btn" v-for="period in periods" :class="{'bg-dark lightest': period.value == fullCalendar.view.name && !(period.value == 'agendaDay' && highlightTodayButton), 'bg-faded dark': period.value != fullCalendar.view.name || (period.value == 'agendaDay' && highlightTodayButton)}" @click="changeView(period)">{{period.label}}</button>
                <button type="button" class="btn" :class="{'bg-dark lightest': highlightTodayButton, 'bg-faded dark': !highlightTodayButton}" @click="goToToday">Today</button>
            </div>
        </div>

        <div class="" v-if="accessPermissionFilter(['admin', 'supervisor'])">
            <button class="btn ml-4 bg-dark" @click="openCreateEvent"><i class="ico ico-add mt-1"></i>New event</button>
        </div>


    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'
    import Arrow from './Arrow'
    import VueDatepicker from 'vuejs-datepicker'

    export default {
        props: {
            rangeFrom: Date,
            rangeTo: Date,
            defaultView: String,
            fullCalendar: {
                type: Object
            }
        },
        data: function() {
            return {
                periods: [
                    {
                        label: 'Month',
                        value: 'month'
                    },
                    {
                        label: 'Week',
                        value: 'agendaWeek'
                    },
                    {
                        label: 'Day',
                        value: 'agendaDay'
                    },
                ],
            }
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getCurrentView',
                'getIsLoadingEvents'
            ]),
            displayDate: function(){
                if(this.getCurrentView == 'month'){
                    return moment(this.getExpandedDay).format('MMMM  YYYY')
                } else if(this.getCurrentView == 'agendaWeek' && this.fullCalendar){
                    if(moment(this.fullCalendar.view.start._d).format('MMM') != moment(this.fullCalendar.view.end._d).subtract(1, 'days').format('MMM')){
                        return moment(this.fullCalendar.view.start._d).format('DD MMM') + ' - ' + moment(this.fullCalendar.view.end._d).subtract(1, 'days').format('DD MMM YYYY')
                    } else {
                        return moment(this.fullCalendar.view.start._d).format('DD') + ' - ' + moment(this.fullCalendar.view.end._d).subtract(1, 'days').format('DD MMM YYYY')
                    }
                } else {
                    return moment(this.getExpandedDay).format('DD-MM-YYYY')
                }
            },
            highlightTodayButton: function() {
                return this.getCurrentView == 'agendaDay' && moment(this.getExpandedDay).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')
            }
        },
        methods: {
            ...mapActions([
                'updateSidebar',
                'openModal',
                'updateSelectedEvent',
                'setAsCreatingSingleEvent'
            ]),
            setExpandedDay: function(date) {
                var newDate = this.formatDate(date);

                // Push new route parameters
                let viewToURL = '';
                switch (this.getCurrentView) {
                    case 'agendaDay':
                        viewToURL = 'day'
                        break;
                    case 'agendaWeek':
                        viewToURL = 'week'
                        break;
                    default:
                    viewToURL = this.getCurrentView;
                }

                this.$router.push({
                    name: 'calendarExpanded',
                    params: {
                        currentView: viewToURL,
                        expandedDay: newDate
                    }
                });

                this.updateSidebar(newDate);

                $('#calendar').fullCalendar('gotoDate', newDate);
            },
            updateArrowDate: function(dates) {
                this.$emit('updateArrowDate', dates);
            },
            updateRangeTo: function(to) {
                this.$emit('updateRanges', { from: null, to: to });
            },
            backToList: function() {
                var vm = this;

                // Animate side panels

                $('.events .list').removeClass('moved-left');
                $('.events .more').addClass('moved-right');

                // Wait until animation is over, then reset selected event

                // setTimeout(function() {
                //     vm.updateSelectedEvent(null);
                // }, 400);
            },
            changeView: function(period){
                    $('#calendar').fullCalendar('changeView', period.value);

                    let viewNameForUrl = '';
                    switch (period.value) {
                        case 'agendaDay':
                            viewNameForUrl = 'day'
                            $('#calendar').fullCalendar('gotoDate', this.getExpandedDay);
                            break;
                        case 'agendaWeek':
                            viewNameForUrl = 'week'
                            break;
                        case 'month':
                            viewNameForUrl = 'month'
                            break;
                        default:

                    }
                    this.$router.push({ name: 'calendarExpanded', params: { currentView: viewNameForUrl, expandedDay: this.getExpandedDay } });
            },
            goToToday: function() {
                this.setExpandedDay(moment())
                $('#calendar').fullCalendar('changeView', 'agendaDay');
            },
            openCreateEvent: function() {
                this.setAsCreatingSingleEvent()
                this.openModal("EventEdit")
            }
        },
        components: {
            Arrow,
            VueDatepicker
        }
    }
</script>


<style lang="scss">
    @import '../../assets/scss/_variables.scss';
    @import '../../assets/scss/_utility.scss';

    .navigator {
        border-bottom: 1px solid $gray-light;

        //fix for hover on agenda view select buttons
        button.bg-dark:hover, button.bg-dark:focus{
            background-color: $dark !important;
        }

        .main-column{
            overflow: visible;
        }

        .date-scroller {
            .vdp-datepicker input {
                text-align: center;
                margin: 0;
                font-size: $font-size-largest;
                background: transparent;
                border: 0;
                padding: 0;
                width: 160px;
            }

            .arrow {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 25px;
                height: 25px;
                border-radius: 50%;
                background-color: $medium;
                color: $lightest;
                text-align: center;
            }
        }
    }

    //loader
    .loaderHolder{
        background: #C5D0DE;
        padding: 7px;
        width: 52px;
        @extend .radius-normal;
    }

    .loader,
    .loader:before,
    .loader:after {
        border-radius: 50%;
        width: 1em;
        height: 1em;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation: load7 1.8s infinite ease-in-out;
        animation: load7 1.8s infinite ease-in-out;
    }
    .loader {
        color: #8CA0B3;
        font-size: 10px;
        // margin: 1px auto;
        position: relative;
        text-indent: -9999em;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }
    .loader:before,
    .loader:after {
        content: '';
        position: absolute;
        top: 0;
    }
    .loader:before {
        left: -1.3em;
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }
    .loader:after {
        left: 1.3em;
    }
    @-webkit-keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 15px 0 0 -1.3em;
        }
        40% {
            box-shadow: 15px 0 0 0;
        }
    }
    @keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 15px 0 0 -1.3em;
        }
        40% {
            box-shadow: 15px 0 0 0;
        }
    }
</style>



// WEBPACK FOOTER //
// Navigator.vue?6e56a2c9